export default __webpack_public_path__ + "static/media/2437.43c55225.png";